import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "content-section" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "row align-items-center" }
const _hoisted_4 = { class: "col-md-3" }
const _hoisted_5 = { class: "card-img" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "col-md-8" }
const _hoisted_8 = { class: "row mb-1" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "col-6 text-end" }, "Beviljat lån", -1)
const _hoisted_10 = { class: "col-6" }
const _hoisted_11 = { class: "row mb-1" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "col-6 text-end" }, "Månadskostnad", -1)
const _hoisted_13 = { class: "col-6" }
const _hoisted_14 = { class: "row mb-1" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "col-6 text-end" }, "Nominell ränta", -1)
const _hoisted_16 = { class: "col-6" }
const _hoisted_17 = { class: "row mb-1" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "col-6 text-end" }, "Effektiv ränta", -1)
const _hoisted_19 = { class: "col-6" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { class: "row mb-1" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "col-6 text-end" }, "Total kostnad", -1)
const _hoisted_23 = { class: "col-6" }
const _hoisted_24 = { class: "row mb-1" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "col-6 text-end" }, "Återbetalningstid", -1)
const _hoisted_26 = { class: "col-6" }
const _hoisted_27 = { class: "row mb-1" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "col-6 text-end" }, "Uppläggningsavgift", -1)
const _hoisted_29 = { class: "col-6" }
const _hoisted_30 = { class: "row mb-1" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "col-6 text-end" }, "Administrationsavgift", -1)
const _hoisted_32 = { class: "col-6" }
const _hoisted_33 = {
  key: 0,
  class: "row mb-1"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "col-6 text-end" }, "Aviavgift", -1)
const _hoisted_35 = { class: "col-6" }
const _hoisted_36 = {
  key: 1,
  class: "row mb-1"
}
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "col-6 text-end" }, "Autogiro", -1)
const _hoisted_38 = { class: "col-6" }
const _hoisted_39 = { class: "col-md-1" }
const _hoisted_40 = { class: "card-btn" }
const _hoisted_41 = {
  key: 0,
  class: "btn btn-sm btn-outline"
}
const _hoisted_42 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-chevron-down",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"
  })
], -1)
const _hoisted_43 = [
  _hoisted_42
]
const _hoisted_44 = {
  key: 1,
  class: "btn btn-sm btn-outline"
}
const _hoisted_45 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "bi bi-chevron-up",
  viewBox: "0 0 16 16"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    d: "M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z"
  })
], -1)
const _hoisted_46 = [
  _hoisted_45
]
const _hoisted_47 = { class: "col-lg-9 offset-lg-3" }
const _hoisted_48 = { class: "card-content" }
const _hoisted_49 = { class: "border-top border-light pt-3 mt-3" }
const _hoisted_50 = { class: "row" }
const _hoisted_51 = { class: "col-lg-4 offset-lg-0 col-md-6 offset-md-3 d-grid my-3" }
const _hoisted_52 = {
  key: 0,
  class: "border-top border-light pt-3 mt-3"
}
const _hoisted_53 = /*#__PURE__*/_createElementVNode("h3", { class: "offer-title" }, "Om lånet", -1)
const _hoisted_54 = { class: "offer-description" }
const _hoisted_55 = {
  key: 1,
  class: "border-top border-light pt-3 mt-3"
}
const _hoisted_56 = /*#__PURE__*/_createElementVNode("h3", { class: "offer-title" }, "Om banken", -1)
const _hoisted_57 = { class: "offer-description" }
const _hoisted_58 = { key: 0 }
const _hoisted_59 = {
  key: 2,
  class: "border-top border-light pt-3 mt-3"
}
const _hoisted_60 = /*#__PURE__*/_createElementVNode("h3", { class: "offer-title" }, "Representativt Exempel", -1)
const _hoisted_61 = { class: "offer-description" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("p", null, " Observera att vi enligt lag behöver visa detta exempel. Det är inte de lånevillkor som du har fått. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["card card-feat", { 'content-card-npb': _ctx.isExpanded(_ctx.offer.id) }]),
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggle(_ctx.offer.id)))
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("img", {
                class: "img-fluid",
                src: _ctx.offer.bank.offerImage
              }, null, 8, _hoisted_6)
            ])
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.formatApprovedAmount(_ctx.offer.approvedAmount)) + " kr", 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.formatMonthlyInstallment(_ctx.offer.monthlyInstallment)) + " kr", 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.formatDecimal(_ctx.offer.interestRate)) + " %", 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.formatDecimal(_ctx.offer.effectiveRate)) + " %", 1)
              ])
            ]),
            (_ctx.isExpanded(_ctx.offer.id))
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _hoisted_22,
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("strong", null, _toDisplayString(parseInt(_ctx.getTotalCost(_ctx.offer)).toLocaleString()) + " kr", 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _hoisted_25,
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.getPaybackDurationText(_ctx.offer)), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _hoisted_28,
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.getArrangementFee(_ctx.offer)) + " kr", 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _hoisted_31,
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.getAministrationFee(_ctx.offer)) + " kr", 1)
                    ])
                  ]),
                  (_ctx.offer.bank.invoiceFee)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                        _hoisted_34,
                        _createElementVNode("div", _hoisted_35, [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.offer.bank.invoiceFee) + " kr", 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.offer.bank.autogiroFee)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                        _hoisted_37,
                        _createElementVNode("div", _hoisted_38, [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.offer.bank.autogiroFee) + " kr", 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("div", _hoisted_40, [
              (!_ctx.isExpanded(_ctx.offer.id))
                ? (_openBlock(), _createElementBlock("button", _hoisted_41, _hoisted_43))
                : (_openBlock(), _createElementBlock("button", _hoisted_44, _hoisted_46))
            ])
          ])
        ]),
        _createVNode(_Transition, { name: "slide" }, {
          default: _withCtx(() => [
            (_ctx.expandedOffers.indexOf(_ctx.offer.id) !== -1)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "row",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
                }, [
                  _createElementVNode("div", _hoisted_47, [
                    _createElementVNode("div", _hoisted_48, [
                      _createElementVNode("div", _hoisted_49, [
                        _createElementVNode("div", _hoisted_50, [
                          _createElementVNode("div", _hoisted_51, [
                            _createVNode(_component_router_link, {
                              to: {
                          name: 'loan_offer_select',
                          params: { id: _ctx.offer.id }
                        },
                              tag: "button",
                              class: "btn btn-primary"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Välj " + _toDisplayString(_ctx.offer.bank.name), 1)
                              ]),
                              _: 1
                            }, 8, ["to"])
                          ])
                        ])
                      ]),
                      (_ctx.offer.bank.offerAdditions)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                            _hoisted_53,
                            _createElementVNode("div", _hoisted_54, [
                              _createElementVNode("p", null, _toDisplayString(_ctx.offer.bank.offerAdditions), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.offer.bank.introDescription)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                            _hoisted_56,
                            _createElementVNode("div", _hoisted_57, [
                              _createElementVNode("p", null, _toDisplayString(_ctx.offer.bank.introDescription), 1),
                              _withDirectives(_createElementVNode("p", null, [
                                (_ctx.headerExpandDescription)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_58, _toDisplayString(_ctx.offer.bank.expandedDescription), 1))
                                  : _createCommentVNode("", true),
                                (!_ctx.headerExpandDescription)
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 1,
                                      href: "#",
                                      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.headerExpandDescription = true), ["prevent"]))
                                    }, "Läs mer"))
                                  : _createCommentVNode("", true)
                              ], 512), [
                                [_vShow, 
                        _ctx.offer.bank.expandedDescription != null &&
                        _ctx.offer.bank.expandedDescription != ''
                      ]
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.offer.bank.representativeText)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                            _hoisted_60,
                            _createElementVNode("div", _hoisted_61, [
                              _hoisted_62,
                              _createElementVNode("p", null, _toDisplayString(_ctx.offer.bank.representativeText), 1)
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ])
    ], 2)
  ]))
}